export default {"src":"/_next/static/media/DEVELOPER_DETAILS_ACTIVE_ICON.a9100df9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};